<template>
  <div
    class="card-container"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="top">
      <div class="title">
        {{ SERVICE_LEVEL_NUMBER_CODES_MAP[serviceLevelInfo.serviceLevel] || '暂无' }}服务等级
      </div>
      <div
        v-if="serviceLevelInfo.bizareaRank<=20"
        class="higher-rank"
      >
        {{ serviceLevelInfo.bizareaRank ? `当前第${serviceLevelInfo.bizareaRank}名·` : '' }}{{ serviceLevelInfo.bizareaRankRatio ? `超过${serviceLevelInfo.bizareaRankRatio}同商圈的商家`:'' }}
      </div>
      <div
        v-else
        class="lower-rank"
      >
        {{ serviceLevelInfo.bizareaRankRatio ? `超过${serviceLevelInfo.bizareaRankRatio}同行`: '' }}
      </div>
    </div>
    <div class="time">
      每月 1 日根据上月表现评定等级
    </div>
  </div>
</template>

<script>
import { INDICATOR_CODES_MAP, SERVICE_LEVEL_NUMBER_CODES_MAP } from '@/constants/serviceLevel';

export default {
  name: 'ServiceLevelCard',
  props: {
    serviceLevelInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      backgroundImage: '',
      INDICATOR_CODES_MAP,
      SERVICE_LEVEL_NUMBER_CODES_MAP,
    };
  },
  mounted() {
    this.getBackgourndImage();
  },
  methods: {
    getBackgourndImage() {
      const { serviceLevel } = this.serviceLevelInfo;
      if (typeof serviceLevel === 'number') {
        switch (serviceLevel) {
        case 1:
          this.backgroundImage = require('@/assets/img/service-level-img/1diamond-card@3x.png');
          break;
        case 2:
          this.backgroundImage = require('@/assets/img/service-level-img/2diamond-card@3x.png');
          break;
        case 3:
          this.backgroundImage = require('@/assets/img/service-level-img/3diamond-card@3x.png');
          break;
        case 4:
          this.backgroundImage = require('@/assets/img/service-level-img/4diamond-card@3x.png');
          break;
        case 5:
          this.backgroundImage = require('@/assets/img/service-level-img/5diamond-card@3x.png');
          break;
        default:
          this.backgroundImage = require('@/assets/img/service-level-img/no-diamond-card@3x.png');
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  height: 2.52rem;
  width: 100%;
  margin-top: 0.12rem;
  padding: 0.3rem 0.24rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .top {
    display: flex;
    align-items: center;
    .title {
      font-size: 0.4rem;
      line-height: 0.4rem;
      font-weight: 600;
      color: #111;
      margin-right: 0.18rem;
    }
    .higher-rank {
      border-radius: 0.08rem;
      height: 0.42rem;
      line-height: 0.42rem;
      padding: 0 0.12rem;
      background-color: #FBF5E8;
      color: #986C24;
      font-size: 0.22rem;
      font-weight: 600;
    }
    .lower-rank {
      border-radius: 0.08rem;
      height: 0.42rem;
      line-height: 0.42rem;
      padding: 0 0.12rem;
      background-color: #F0F0F0;
      color: #666;
      font-size: 0.22rem;
    }
  }
  .time {
    margin-top: 0.24rem;
    font-size: 0.24rem;
    line-height: 0.24rem;
    color: #888;
  }
}
</style>
